import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function PricingSection() {
  return <section id="compra" className="bg-[#2c3e50] py-16 md:py-24 px-4 text-white relative overflow-hidden scroll-mt-16" data-id="element-102">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-103">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-104"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-105"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-106">
        <div className="text-center mb-12" data-id="element-107">
          <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded animate-bounce mb-4" data-id="element-108">
            ⏰ Oferta por tiempo limitado
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-6 font-['Oswald'] uppercase" data-id="element-109">
            Accedé al Pack Completo <br data-id="element-110" />
            <span className="text-yellow-400" data-id="element-111">+ los 3 Bonos de regalo</span>
          </h2>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl shadow-2xl overflow-hidden max-w-2xl mx-auto border-4 border-yellow-400" data-id="element-112">
          <div className="bg-gray-100 p-6 border-b border-gray-200 text-center" data-id="element-113">
            <h3 className="text-xl font-bold text-gray-600 uppercase tracking-wide" data-id="element-114">
              📦 Lo que vas a recibir hoy:
            </h3>
          </div>

          <div className="p-8 md:p-10" data-id="element-115">
            <ul className="space-y-4 mb-8" data-id="element-116">
              <li className="flex items-center gap-3 text-lg font-bold" data-id="element-117">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-118" />
                <span data-id="element-119">6 Tomos completos del cuerpo humano</span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-120">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-121" />
                <span data-id="element-122">Bono #1: Sistema de Evaluación</span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-123">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-124" />
                <span data-id="element-125">Bono #2: MegaPack Juegos Didácticos</span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-126">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-127" />
                <span data-id="element-128">Bono #3: Planificador Estratégico</span>
              </li>
            </ul>

            <div className="grid grid-cols-3 gap-2 text-center text-sm text-gray-500 mb-8 border-t border-b border-gray-100 py-4" data-id="element-129">
              <div data-id="element-130">Material descargable</div>
              <div className="border-l border-r border-gray-100" data-id="element-131">
                Acceso inmediato
              </div>
              <div data-id="element-132">Organización profesional</div>
            </div>

            <div className="text-center mb-8" data-id="element-133">
              <p className="text-gray-500 line-through text-xl mb-1" data-id="element-134">
                Valor total real: $ 49990
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-135">
                <span className="text-2xl font-bold text-gray-700" data-id="element-136">
                  HOY SOLO:
                </span>
                <span className="text-5xl md:text-6xl font-black text-[#c0392b]" data-id="element-137">
                  $ 19990
                </span>
              </div>
            </div>

            <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white text-2xl md:text-3xl font-black py-6 px-4 rounded-lg shadow-[0_6px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase flex items-center justify-center gap-2 animate-pulse mb-6 no-underline" data-id="element-138">
              👉 Obtener mi pack completo hoy
            </a>

            <div className="flex justify-center gap-4 md:gap-8 text-sm text-gray-500 font-medium" data-id="element-139">
              <span className="flex items-center gap-1" data-id="element-140">
                <CheckCircle className="w-4 h-4" data-id="element-141" /> Un solo pago
              </span>
              <span className="flex items-center gap-1" data-id="element-142">
                <CheckCircle className="w-4 h-4" data-id="element-143" /> Descarga digital
              </span>
              <span className="flex items-center gap-1" data-id="element-144">
                <CheckCircle className="w-4 h-4" data-id="element-145" /> Acceso de por vida
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}